export default {
  'deliveryPlatformOrderingSettings.description': '简化的外卖平台订单体验——精简接单流程，减少人工错误！',
  'deliveryPlatformOrderingSettings.secondaryDescription':
    '统一在一个商家后台轻松管理所有第三方外卖平台的店铺营业时间和营业状态。减少重复工作，简化运营流程，提升整体效率，降低出错率。',
  'deliveryPlatformOrderingSettings.section.orderAcceptance': '接单状态',
  'deliveryPlatformOrderingSettings.section.orderAcceptance.description':
    '您可以在此处更新您的外卖平台店铺状态，以控制顾客是否可以在外卖平台下单。该操作可能需要几分钟才能在平台生效，因此我们建议必要时直接在平台上验证状态是否更新成功。',
  'deliveryPlatformOrderingSettings.grubhubOrderAccepatance': 'GrubHub只能在营业时间内调整店铺接单状态。',
  'deliveryPlatformOrderingSettings.section.orderAcceptance.on': '接单中',
  'deliveryPlatformOrderingSettings.section.orderAcceptance.off': '暂不接单',
  'deliveryPlatformOrderingSettings.section.businessHours': '平台店铺营业时间',
  'deliveryPlatformOrderingSettings.section.businessHours.description':
    '您可以在此处更新您的外卖平台店铺营业时间，此处更新将应用于所有已整合的外卖平台。该操作可能需要几分钟才能在平台生效，因此我们建议必要时直接在平台上查看店铺营业时间是否更新成功',
  'deliveryPlatformOrderingSettings.section.holidays': '节假日',
  'deliveryPlatformOrderingSettings.section.holidays.description':
    '如果您的平台店铺需要长时间关闭，请在此处添加具体日期。某些平台可能无法在这里设置，因此强烈建议您完成设置后去对应平台检查设置是否更新。',
  'deliveryPlatformOrderingSettings.section.delivectPortal': 'Deliverect商家后台',
  'deliveryPlatformOrderingSettings.section.delivectPortal.description':
    '我们通过Deliverect帮助餐厅在我们的POS上管理第三方在线订单。您可以通过Chowbus的商家后台查看外卖订单并直接更新菜单、营业时间和平台店铺状态。如想查看更多信息，请登录Deliverect的商家后台。',
  'deliveryPlatformOrderingSettings.errorTitle': '哎呀！好像出了一点问题',
  'deliveryPlatformOrderingSettings.updateBusinessStateTitle':
    '以下平台无法更新店铺营业状态，请联系我们客服获取更多详情。',
  'deliveryPlatformOrderingSettings.contactCustomerSupport': '请联系我们客服获取更多详情。',

  'deliveryPlatformOrderingSettings.action.addTime': '添加时间',
  'deliveryPlatformOrderingSettings.action.logIn': '登录',
};
